import NotFoundSo from "./notFoundSo";
function NotFound_SO(){
    return (
        <>
        <NotFoundSo />
        </>
    )
}


export default NotFound_SO